module.exports = __webpack_public_path__ + "img/1.fe83306d.jpg";